// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".SuggestedUserCard-cls1__b6dd4a66f79431d1db98{/*!*/}.SuggestedUserCard-cls2__ec5dfffdaf11a64fd774{flex-shrink:0}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"cls1": "SuggestedUserCard-cls1__b6dd4a66f79431d1db98",
	"cls2": "SuggestedUserCard-cls2__ec5dfffdaf11a64fd774 SuggestedUserCard-cls1__b6dd4a66f79431d1db98"
};
export default ___CSS_LOADER_EXPORT___;
